export const REQUEST_SIZE = 'zola/cart/REQUEST_SIZE';
export const RECEIVE_SIZE = 'zola/cart/RECEIVE_SIZE';
export const REQUEST_CART = 'zola/cart/REQUEST_CART';
export const RECEIVE_CART = 'zola/cart/RECEIVE_CART';
export const RESET_CART = 'zola/cart/RESET_CART';
